function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

const LargeMonthViewEventChip = ({event, setEditEvent, setEventToEdit}) => {

    const openEvent = (e) => {
        setEditEvent(true)
        setEventToEdit(e)
      }

    return (
        <li key={event.id} className="list-none">
            <div id="existing-event" onClick={() => openEvent(event)} className={`group flex transition-bg duration-300 hover:bg-gray-200 cursor-pointer py-0 px-1 m-1 ${event.isIntro ? 'bg-amber-100' : event.color.bgColor200} rounded-md`}>
                <div id="existing-event" className={`w-1 h-3 mt-1 rounded-sm ${event.color.bgColor500}`}></div>
                <time id="existing-event" dateTime={event.datetime} className="hidden flex-none ml-1 font-thin text-gray-900 mt-0.5 xl:block text-xs">{event.time}</time>
                <p id="existing-event" className={classNames( event.isIntro ? 'text-green-700 font-extrabold' : `${event.color.textColor800}` ,"flex-auto truncate font-bold my-0 ml-2 w-1 py-0.5 text-left text-xs")}>{event.name}</p>
            </div>
        </li>
    )
}
export default LargeMonthViewEventChip